import { Component, inject, OnInit } from '@angular/core';

import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { InvoiceLine } from 'app/core/model/entity-model';
import validationEngine from 'devextreme/ui/validation_engine';
import { DevExtremeModule } from 'devextreme-angular';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-invoice-line-dialog',
    templateUrl: './invoice-line-dialog.component.html',
    styleUrls: ['./invoice-line-dialog.component.scss'],
    imports: [DevExtremeModule],
})
export class InvoiceLineDialogComponent implements OnInit {
    uow = inject(ArkUnitOfWork);
    auth = inject(AuthService);
    appInfo = inject(AppInformationService);

    result = new Subject<{ success: boolean; value?: InvoiceLine }>();
    quantity: number = null;
    invoiceLine: InvoiceLine;
    invoiceId: number;
    lineNumber: number;

    async ngOnInit() {
        await this.appInfo.pleaseWaitShow();
        if (!this.invoiceLine) {
            this.invoiceLine = this.uow.invoiceLines.createEntity({
                quantity: this.quantity,
                price: 0,
                invoiceId: this.invoiceId,
                lineNumber: this.lineNumber,
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            }) as InvoiceLine;
        }
        await this.appInfo.pleaseWaitHide();
    }

    save() {
        const success = this.valid();
        if (!success) return;

        this.result.next({ success: true, value: this.invoiceLine });
    }

    cancel() {
        this.invoiceLine.entityAspect.rejectChanges();

        this.result.next({ success: false });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('invoiceLineValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('invoiceLineValidationGroup');
            return result.isValid;
        } else return false;
    }
}
